import React from "react";
import {
    BooleanField,
    SimpleShowLayout,
    Filter,
    DateField,
    List,
    TextField,
    TextInput,
    ReferenceField,
    Datagrid,
    BooleanInput,
    ReferenceInput,
    required,
    SelectInput,
    ImageInput,
    ImageField,
    maxLength,
    NumberInput
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";

const MessageFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId"/>
    <TextInput label="شناسه مکالمه" source="conversationId"/>
    <TextInput label="شناسه فرستنده" source="senderUserId"/>
    <TextInput label="شناسه کاربران دیده" source="seenByUsersId"/>
    <TextInput label="متن" source="text"/>
    <BooleanInput label="حذف شده؟" source="isDeleted"/>
    <BooleanInput label="is system?" source="isSystem"/>
  </Filter>
);

export const MessageList = (props) => (
  <List {...props} filters={<MessageFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation">
            <TextField source="title" />
        </ReferenceField>
      <TextField source="text"/>
        <ReferenceField link="show" label="کاربر" source="senderUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
      <ReferenceField link="show" label="لینک پیوست" source="attachmentId" reference="attachment" >
        <TextField source="url"/>
      </ReferenceField>
      <BooleanField source="isDeleted"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const MessageShow = (props) => (
    <ShowView {...props} noDel={true}>
        <SimpleShowLayout>
            <TextField source="objectId"/>
            <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
                <TextField source="title"/>
            </ReferenceField>
            <TextField source="text"/>
            <ReferenceField link="show" label="کاربر" source="senderUserId" reference="user" >
                <TextField source="name"/>
            </ReferenceField>
            <TextField source="seenByUsersId"/>
            <ReferenceField link="show" label="لینک پیوست" source="attachmentId" reference="attachment" >
                <TextField source="url"/>
            </ReferenceField>
            <BooleanField source="isDeleted"/>
            <TextField source="messageHistory"/>
            <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
            <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        </SimpleShowLayout>
    </ShowView>
);

export const MessageEdit = (props) => (
    <EditView {...props} noDel={true}>
        <BooleanInput source="isDeleted" validate={required()}/>
    </EditView>
);
